import React from 'react';
import { Button } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface GoToNewVersionButtonProps {
    onClick: () => void;
    children?: React.ReactNode;
    disabled?: boolean;
}

const GoToNewVersionButton: React.FC<GoToNewVersionButtonProps> = ({ onClick, children, disabled }) => {
    return (
        <Button
            variant="contained"
            startIcon={<AutoAwesomeIcon fontSize="small"/>}
            disabled={disabled}
            sx={{
                px: 2,
                py: 0.75,
                borderRadius: 2,
                fontWeight: 'bold',
                textTransform: 'none',
                fontSize: '0.85rem',
                background: 'linear-gradient(45deg, #2c5aa0, #42a5f5)',
                color: '#fff',
                boxShadow: '0px 3px 8px rgba(0,0,0,0.2)',
                '&:hover': {
                    background: 'linear-gradient(45deg, #013b71, #013b71)',
                    boxShadow: '0px 5px 12px rgba(0,0,0,0.25)',
                },
            }}
            onClick={onClick}
        >
            {children || 'Go to New Version'}
        </Button>
    );
};

export default GoToNewVersionButton;